import React from "react";
import PropTypes from "prop-types";

export default function PageHeader({ title, subtitle, right }) {
  return (
    <div className="page-header d-flex justify-content-between align-items-center py-3 px-4 mb-4">
      <div>
        {subtitle && <p className="page-eyebrow mb-1 text-muted">{subtitle}</p>}
        <h1 className="h-title mb-0">{title}</h1>
      </div>
      <div className="subtle">{right}</div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  right: PropTypes.node,
};
